import { render, staticRenderFns } from "./ReportsServicesAllView.vue?vue&type=template&id=04992887&scoped=true"
import script from "./ReportsServicesAllView.vue?vue&type=script&lang=js"
export * from "./ReportsServicesAllView.vue?vue&type=script&lang=js"
import style0 from "./ReportsServicesAllView.vue?vue&type=style&index=0&id=04992887&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04992887",
  null
  
)

export default component.exports